module.exports = __webpack_public_path__ + "media/images/icons/outlined/ant-design-19a09c33ae0027c81c9dade692d3ece0.svg";